/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import useCodigosInfraccionAPI, { CodigoInfraccion } from "./hooks/useCodigosInfraccionAPI";


export default () => {
    const api = useCodigosInfraccionAPI();
    const createPage = "/codigos-infraccion/guardar"
    const editPage = "/codigos-infraccion/guardar/{Id}"

    const [codigoFilterForm] = Form.useForm();
    const [articuloFilterForm] = Form.useForm();
    const [incisoFilterForm] = Form.useForm();
    const [categoriaFilterForm] = Form.useForm();
    const [etiquetaFilterForm] = Form.useForm();

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Codigo != null ? `contains(Codigo,'${filters!.Codigo![0]}')` : "",
            filters?.Articulo != null ? `contains(Articulo,'${filters!.Articulo![0]}')` : "",
            filters?.Inciso != null ? `contains(Inciso,'${filters!.Inciso![0]}')` : "",
            filters?.Categoria != null ? `contains(Categoria,'${filters!.Categoria![0]}')` : "",
            filters?.Etiqueta != null ? `contains(Etiqueta,'${filters!.Etiqueta![0]}')` : "",
        ];
    }


    useEffect(() => {

    }, []);

    return (
        <MainLayout>
            <DataTable<CodigoInfraccion, CodigoInfraccion>
                list={api.list}
                delete={api.delete}
                createAction={{
                    label: "Agregar código de infracción",
                    path: createPage
                }}
                deleteMultipleAction
                defaultSortOrder={"Codigo desc"}
                selectionType='checkbox'
                title={"Códigos de infracción"}
                generateFilters={generateFilters}
                editItemAction={editPage}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar código ${item.Codigo} (${item.Etiqueta})?`}
                defaultPageSize={25}

            >
                <Table.Column<CodigoInfraccion>
                    width={`25%`}
                    title="Código"
                    dataIndex={"Codigo"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Codigo!.toString()}
                            formValue={{ Codigo: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Codigo"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={codigoFilterForm} >
                                <Form.Item name={"Codigo"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Código...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />


                <Table.Column<CodigoInfraccion>
                    width={`25%`}
                    title="Artículo"
                    dataIndex={"Articulo"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Articulo?.toString() ?? "-"}
                            formValue={{ Articulo: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Articulo"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={articuloFilterForm} >
                                <Form.Item name={"Articulo"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Código...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<CodigoInfraccion>
                    width={`15%`}
                    title="Inciso"
                    dataIndex={"Inciso"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Inciso?.toString() ?? "-"}
                            formValue={{ Inciso: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Inciso"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={incisoFilterForm} >
                                <Form.Item name={"Inciso"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Código...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<CodigoInfraccion>
                    width={`25%`}
                    title="Categoria"
                    dataIndex={"Categoria"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Categoria!.toString()}
                            formValue={{ Categoria: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Categoria"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={categoriaFilterForm} >
                                <Form.Item name={"Categoria"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Código...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<CodigoInfraccion>
                    width={`25%`}
                    title="Descripcion"
                    dataIndex={"Descripcion"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Descripcion!.toString()}
                            formValue={{ Descripcion: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Descripcion"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                />

                <Table.Column<CodigoInfraccion>
                    width={`20%`}
                    title="Etiqueta"
                    dataIndex={"Etiqueta"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<CodigoInfraccion>>
                            save={(data) => api.save({ ...data, ...{ SegmentosUf: undefined, EtiquetasImagenes: undefined } })}
                            id={record.Id}
                            render={(value) => value.Etiqueta!.toString()}
                            formValue={{ Etiqueta: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Etiqueta"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={etiquetaFilterForm} >
                                <Form.Item name={"Etiqueta"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Código...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />




            </DataTable>
        </MainLayout>
    );

};